import axios from 'axios'
import React, {useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { successToast, errorToast } from '../../shared/notification'
import LoadingSpinner from '../../shared/Spinner/LoadingSpinner'

const Alarm = ({logo}) => {
    let {id} = useParams()
    const [submitting, setSubmitting] = useState(false)

    const removeAlarm = () => {
        setSubmitting(true)
        axios.get(`${process.env.REACT_APP_API_URL}/alarm/messenger/delete/${id}`).then(res=>{
            setSubmitting(false)
            console.log(res)
            successToast(res.data)

        }).catch(err=>{
            setSubmitting(false)
            console.log(err)
            errorToast('Alarm has been removed. Please contact administrator if otherwise.')
        })
    }
    

    return (
        <>
        {submitting && <LoadingSpinner />}
        <div>
            <img
                src={'/'+logo}
                className="d-flex justify-content-center mx-auto"
                width="90px"
                alt=""
            />
        </div>
        <div className='' style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh'
        }}>
            <button className="btn btn-lg btn-primary" onClick={removeAlarm}>
                Remove
            </button>
        </div>
        </>
    )
}

export default Alarm